import React, { useState } from 'react';
import { Button, Card, CardHeader, CardBody, Row, Col, FormGroup, Label, Input, Table } from 'reactstrap';

const TaxPackages = ({ formData, setFormData, activeColorStyle, salesLocationId }) => {
    // Safety check - if formData is undefined, provide default values
    const safeFormData = formData || {};
    const [showTaxPackageForm, setShowTaxPackageForm] = useState(false);
    const [currentTaxPackage, setCurrentTaxPackage] = useState({
        description: '',
        is_default: false,
        selected_rates: []
    });
    const [editingTaxPackageIndex, setEditingTaxPackageIndex] = useState(null);

    // Available tax rates (mock data - should come from API)
    const availableTaxRates = [
        { id: 1, state: 'TX', category: 'Inventory Tax', description: 'Inventory Tax', rate: '0.1893%' },
        { id: 2, state: 'TX', category: 'State Sales Tax', description: 'State Sales Tax', rate: '6.2500%' }
    ];

    const handleToggleTaxRate = (rateId) => {
        setCurrentTaxPackage(prev => {
            const isSelected = prev.selected_rates.includes(rateId);
            return {
                ...prev,
                selected_rates: isSelected 
                    ? prev.selected_rates.filter(id => id !== rateId)
                    : [...prev.selected_rates, rateId]
            };
        });
    };

    const handleAddTaxPackage = () => {
        if (editingTaxPackageIndex !== null) {
            const updatedPackages = [...safeFormData.tax_packages];
            updatedPackages[editingTaxPackageIndex] = currentTaxPackage;
            setFormData(prev => ({ ...prev, tax_packages: updatedPackages }));
            setEditingTaxPackageIndex(null);
        } else {
            setFormData(prev => ({ ...prev, tax_packages: [...prev.tax_packages, currentTaxPackage] }));
        }
        setCurrentTaxPackage({ description: '', is_default: false, selected_rates: [] });
        setShowTaxPackageForm(false);
    };

    const handleEditTaxPackage = (index) => {
        if (editingTaxPackageIndex === index) {
            // If clicking on same row, close the edit form
            setEditingTaxPackageIndex(null);
            setCurrentTaxPackage({ description: '', is_default: false, selected_rates: [] });
        } else {
            // Open edit form for clicked row
            setCurrentTaxPackage(safeFormData.tax_packages[index]);
            setEditingTaxPackageIndex(index);
        }
        setShowTaxPackageForm(true);
    };

    const handleDeleteTaxPackage = (index) => {
        const deletedPackage = safeFormData.tax_packages[index];
        const updatedPackages = safeFormData.tax_packages.filter((_, i) => i !== index);
        setFormData(prev => ({ ...prev, tax_packages: updatedPackages }));
        
        // TODO: When API integration is added, send deleted package with is_deleted flag
        // if (salesLocationId && deletedPackage) {
        //     updateSalesLocation({
        //         tax_packages: {
        //             ...deletedPackage,
        //             is_deleted: true
        //         }
        //     });
        // }
    };

    const handleCancelTaxPackage = () => {
        setCurrentTaxPackage({ description: '', is_default: false, selected_rates: [] });
        setEditingTaxPackageIndex(null);
        setShowTaxPackageForm(false);
    };

    return (
        <div className="">
            {!showTaxPackageForm ? (
                <>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                        <Button 
                            size="sm" 
                            style={{ ...activeColorStyle, color: 'white' }}
                            onClick={() => {
                                setEditingTaxPackageIndex(null); // Close any open edit form
                                setShowTaxPackageForm(true);
                            }}
                        >
                            Add Tax Package
                        </Button>
                    </div>

                    {safeFormData.tax_packages?.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                            No tax packages added yet
                        </div>
                    ) : (
                        <Table responsive>
                            <thead className="text-primary">
                                <tr>
                                    <th className="text-center">#</th>
                                    <th>Tax Package Description</th>
                                    <th>Is Default</th>
                                    <th className="text-right"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {safeFormData.tax_packages?.map((pkg, idx) => (
                                    <tr key={idx}>
                                        <td className="text-center">{idx + 1}</td>
                                        <td>{pkg.description}</td>
                                        <td>{pkg.is_default ? 'Yes' : 'No'}</td>
                                        <td className="text-right">
                                            <div className="actions-right">
                                                <Button
                                                    color="warning"
                                                    size="sm"
                                                    className="btn-icon btn-link like"
                                                    onClick={() => handleEditTaxPackage(idx)}
                                                >
                                                    <i className="tim-icons icon-pencil" />
                                                </Button>
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    className="btn-icon btn-link like"
                                                    onClick={() => handleDeleteTaxPackage(idx)}
                                                >
                                                    <i className="tim-icons icon-simple-remove" />
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                </>
            ) : (
                <Card>
                    <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3 style={{ margin: 0 }}>CREATE NEW TAX PACKAGE</h3>
                        <Button
                            color="link"
                            onClick={handleCancelTaxPackage}
                            style={{ fontSize: '24px' }}
                        >
                            <i className="tim-icons icon-simple-remove" />
                        </Button>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className='form-control-label'>Tax Package Description</Label>
                                    <Input
                                        type="text"
                                        value={currentTaxPackage.description}
                                        onChange={(e) => setCurrentTaxPackage(prev => ({ ...prev, description: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className='form-control-label'>Is Default Tax Package:</Label>
                                    <div style={{ marginTop: '10px' }}>
                                        <Input
                                            type="checkbox"
                                            checked={currentTaxPackage.is_default}
                                            onChange={(e) => setCurrentTaxPackage(prev => ({ ...prev, is_default: e.target.checked }))}
                                            style={{ width: '20px', height: '20px' }}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        <h5 className="mt-4 mb-3">SELECT TAX RATES FOR THIS PACKAGE</h5>
                        <Table responsive>
                            <thead className="text-primary">
                                <tr>
                                    <th>Select</th>
                                    <th>State</th>
                                    <th>Category</th>
                                    <th>Desc</th>
                                    <th>Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                {availableTaxRates.map((rate) => (
                                    <tr key={rate.id}>
                                        <td>
                                            <Input
                                                type="checkbox"
                                                checked={currentTaxPackage.selected_rates.includes(rate.id)}
                                                onChange={() => handleToggleTaxRate(rate.id)}
                                            />
                                        </td>
                                        <td>{rate.state}</td>
                                        <td>{rate.category}</td>
                                        <td>{rate.description}</td>
                                        <td>{rate.rate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <Row className="mt-4">
                            <Col className="text-right">
                                <Button 
                                    style={{ ...activeColorStyle, color: 'white' }}
                                    onClick={handleAddTaxPackage}
                                >
                                    UPDATE PACKAGE
                                </Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            )}
        </div>
    );
};

export default TaxPackages;

